<bca-product-dialog
  (productSelected)="onProductSelected($event)"
  (closeProductDialog)="closeProductDialog()"
></bca-product-dialog>
<bca-choose-route-dialog
  (onRouteSelected)="onCloseRouteDialog()"
></bca-choose-route-dialog>
<div>
  <div>
    <div class="tile__title">
      <nes-highlight-box class="nes-mb-3" type="info">
        <p class="nes-text-default">
          {{ "COMPOSE.PRODUCTS_OVERVIEW.HIGHLIGHT_BOX.TEXT" | translate }}

          <nes-link (nesOnClick)="goToMijnNSZakelijk()">{{
            "COMPOSE.PRODUCTS_OVERVIEW.HIGHLIGHT_BOX.LINK_TEXT" | translate
          }}</nes-link>
        </p>
      </nes-highlight-box>
      <h1 [cypress]="'page_title'" class="nes-h2 nes-mb-3">
        {{ "COMPOSE.PRODUCTS_OVERVIEW.PAGE_HEADER.TITLE" | translate }}
      </h1>
      <p class="nes-mb-5">
        {{ "COMPOSE.PRODUCTS_OVERVIEW.PAGE_HEADER.SUBTEXT" | translate }}
      </p>
      <div class="richText mb-3">
        <nes-text-list
          list-type="unordered"
          size="base"
          color="text-body"
          class="nes-mb-2"
        >
          <nes-text-list-item
            *ngFor="
              let item of 'COMPOSE.PRODUCTS_OVERVIEW.PAGE_HEADER.CHECKLIST'
                | translate
            "
            ><span [innerHTML]="item"></span
          ></nes-text-list-item>
        </nes-text-list>
      </div>
      <h2 class="nes-h3 nes-mb-3">
        {{
          "COMPOSE.PRODUCTS_OVERVIEW.SELECT_PRODUCT_HEADER.TITLE" | translate
        }}
      </h2>
      <p class="nes-mb-5">
        {{
          "COMPOSE.PRODUCTS_OVERVIEW.SELECT_PRODUCT_HEADER.SUB_TEXT" | translate
        }}
      </p>
      @if (productsLoading$ | async) {
        <div>
          <app-products-overview-skeleton />
        </div>
      } @else {
        <div class="nes-flex nes-flex-col nes-gap-5 nes-mb-8">
          <h3 class="nes-h4">
            {{
              "COMPOSE.PRODUCTS_OVERVIEW.WITHOUT_SUBSCRIPTION_HEADER"
                | translate
            }}
          </h3>
          @for (product of allProducts$ | async; track product.identifier) {
            @if (product.identifier === "BCB") {
              <div class="nes-h-full">
                <bca-product-card
                  [id]="product.identifier"
                  [cypress]="product.identifier"
                  [showNewProductLayout]="!showNewProductLayout"
                  [isMobileView]="mobileQueryMatches$ | async"
                  [hideSticker]="hideSticker$ | async"
                  [isSelected]="
                    (selectedProduct$ | async)?.identifier ===
                    product.identifier
                  "
                  [isPreSelected]="product | preSelected"
                  [routeLoading]="routeLoading$ | async"
                  [product]="product"
                  [configuredProduct]="
                    product.identifier === ProductIdentifier.Traject
                      ? (configuredProduct$ | async)
                      : null
                  "
                  (selected)="onProductSelected($event)"
                  (chooseRoute)="onRouteDialogOpened()"
                  (readMore)="onReadMoreOpened($event)"
                />
              </div>
            }
          }
        </div>

        <div class="nes-flex nes-flex-col nes-gap-5 nes-mb-5">
          <h3 class="nes-h4">
            {{
              "COMPOSE.PRODUCTS_OVERVIEW.WITH_SUBSCRIPTION_HEADER.TITLE"
                | translate
            }}
          </h3>
          <div class="nes-flex nes-flex-col nes-mb-3">
            <div>
              {{
                "COMPOSE.PRODUCTS_OVERVIEW.WITH_SUBSCRIPTION_HEADER.SUB_TEXT"
                  | translate
              }}
            </div>
            <div class="nes-italic">
              {{ "COMPOSE.PRODUCTS_OVERVIEW.VAT_INCLUDED" | translate }}
            </div>
          </div>

          @for (product of allProducts$ | async; track product.identifier) {
            @if (product.identifier !== "BCB") {
              <div class="nes-h-full">
                <bca-product-card
                  [id]="product.identifier"
                  [cypress]="product.identifier"
                  [showNewProductLayout]="!showNewProductLayout"
                  [isMobileView]="mobileQueryMatches$ | async"
                  [hideSticker]="hideSticker$ | async"
                  [isSelected]="
                    (selectedProduct$ | async)?.identifier ===
                    product.identifier
                  "
                  [isPreSelected]="product | preSelected"
                  [routeLoading]="routeLoading$ | async"
                  [product]="product"
                  [configuredProduct]="
                    product.identifier === ProductIdentifier.Traject
                      ? (configuredProduct$ | async)
                      : null
                  "
                  (selected)="onProductSelected($event)"
                  (chooseRoute)="onRouteDialogOpened()"
                  (readMore)="onReadMoreOpened($event)"
                />
              </div>
            }
          } @empty {
            <p></p>
          }
        </div>
      }
    </div>
  </div>
  @if (!(productsLoading$ | async)) {
    @if (selectedProduct$ | async; as product) {
      <bca-choose-extras
        (addProduct)="addNewProduct()"
        [selectedProduct]="product"
      />
    }
  }
  <div class="mt-3">
    <div class="nes-w-full nes-flex nes-justify-between nes-items-end nes-flex-wrap">
      <nes-button
        icon-leading="plus-circle"
        variant="tertiary"
        id="order_more_cards_button"
        [disabled]="!(allowNewProduct$ | async) || (routeLoading$ | async)"
        (click)="addNewProduct()"
      >
        {{ "BUTTON.ADD_PRODUCT" | translate }}
      </nes-button>

      <div class="nes-flex nes-flex-col">
        <nes-button
          variant="brand"
          icon-trailing="true"
          nes-id="to_userdata_page"
          id="to_userdata_page"
          [disabled]="routeLoading$ | async"
          (click)="nextRoute()"
        >
          {{ "COMPOSE.CONTINUE_BUTTON" | translate }}
        </nes-button>
        @if (showCtaSubText$ | async) {
          <nes-text size="sm" color="text-secondary" class="nes-mt-2">
            {{ "COMPOSE.CTA_SUB_TEXT" | translate }}
          </nes-text>
        }
      </div>
    </div>
  </div>
</div>
